import styled from 'styled-components';

export const RightSide = styled.div`
  display: flex;
  gap: 9px;
  flex-wrap: wrap;

  .team {
    display: flex;
    gap: 10px;
    width: 265px;
    background: var(--color-surface);
    border-radius: 5px;

    .team-shortName {
      flex: 0 0 auto;
      width: 72px;
      height: 72px;
      background: var(--color-surface-muted);
      border-radius: 5px;
      font-style: normal;
      text-align: center;
      font-weight: 600;
      font-size: 36px;
      line-height: 72px;
      letter-spacing: 0.01em;
      color: var(--color-text);
      text-transform: uppercase;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .team-right {
      padding: 10px 0;

      .team-name {
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 150%;
        color: var(--color-accent);
        width: 173px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .team-org {
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 150%;
        color: var(--color-text-muted);
        width: 173px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
`;
